import { ILoader, loaderSettings } from "./ILoader";

export class ChildElementDisablerLoader implements ILoader {

    loader: HTMLElement = null;
    loaderCollection: HTMLCollection= null;

    elementCollection: HTMLCollection = null;

    hideElement: HTMLElement = null;
    hideElementCollection: HTMLCollection = null;

    _settings: loaderSettings = null;
    _originalElementCollection: HTMLCollection = null;

    constructor(loaderElement: any, elements: any, hideElement: any, settings: loaderSettings )
    {
        //document.getElementsByTagName("FORM") does not add links to collection therefore you don't get the disablity of links with it
        //document.getElementById("loginform") has also links in the collection so if you need to disable links use it instead of getElementsByTagName
        //if you don't need links you can use getElementsByTagName it's also faster
        this.initSettings(settings);

        if (this.isElementObject(loaderElement)) {
            if (HTMLCollection.prototype.isPrototypeOf(loaderElement)) {
                this.loaderCollection = <HTMLCollection>loaderElement;               
            }
            else if (this.isElement(loaderElement)) {
                this.loader = loaderElement;            
            }
        }

        if (this.isElementObject(elements)) {

            if (HTMLCollection.prototype.isPrototypeOf(elements))
            {
                this._originalElementCollection = Object.assign({}, <HTMLCollection>elements);
                if (this._settings.excludeAlreadyDisabled == true) {
                    this.excludeDisabledFromCollection(<HTMLCollection>elements);
                }
                this.elementCollection =<HTMLCollection>elements;               
            }
            else if (this.isElement(elements))
            {
                this._originalElementCollection = Object.assign({}, elements);
                if (this._settings.excludeAlreadyDisabled== true) {
                    this.excludeDisabledFromCollection((<HTMLElement>elements).children);
                }
                this.elementCollection = (<HTMLElement>elements).children;               
            }
        }

        if (this.isElementObject(hideElement)) {
            if (HTMLCollection.prototype.isPrototypeOf(hideElement)) {
                this.hideElementCollection = <HTMLCollectionOf<HTMLElement>>hideElement;

            }
            else if (this.isElement(hideElement)) {
                this.hideElement = hideElement;
            }
        }

        return this;
    }

    private initSettings(settings: loaderSettings) {
        this._settings = settings;
        if (this._settings === window['undefined'] || this._settings == null) {
            this._settings = new loaderSettings();
            this._settings.disablableChildTags = ["INPUT", "SELECT", "BUTTON", "A", "TEXTAREA"];
            this._settings.excludeAlreadyDisabled = true;
        }

        if (this._settings.disablableChildTags === window['undefined'] || this._settings.disablableChildTags == null) {
            this._settings.disablableChildTags = ["INPUT", "SELECT", "BUTTON", "A", "TEXTAREA"];
        }

        if (this._settings.excludeAlreadyDisabled === window['undefined'] || this._settings.excludeAlreadyDisabled == null) {
            this._settings.excludeAlreadyDisabled = true;
        }
    }

    load(loading: boolean): void
    {
        if (loading == true) {
            this.internalLoading();
        }
        else if (loading == false) {
            this.internalNotLoading();
        }
    }

    private excludeDisabledFromCollection(collection: any) {

        var self = this;
        var tags = this._settings.disablableChildTags;
        if (collection !== window['undefined'])
        {

            if (HTMLCollection.prototype.isPrototypeOf(collection)) {
                for (var i = collection.length - 1; i > -1; i--) {
                    if (self.isElement(collection[i])) {
                        self.excludeDisabledFromCollection(collection[i]);
                    }
                }
            }
            else if (collection.children !== window['undefined'] && HTMLCollection.prototype.isPrototypeOf(collection.children) && collection.children.length > 0)
            {
                self.excludeDisabledFromCollection(collection.children);
            }

            if (self.isElement(collection[0]))
            {
                for (var i = collection.length - 1; i > -1; i--)
                {
                    self.excludeDisabledFromCollection(collection[i]);
                }
            }

            //If element is disabled or it's link which pointerEvents is 'none' == disabled link. Then we add exclude-undisability-class that prevent's undisabling elements that are already disabled
            if (self.isElement(collection) && ((<HTMLElement>collection).hasAttribute("disabled") || (<HTMLElement>collection).hasAttribute("readonly")) ||
                ((<HTMLElement>collection).nodeName == "A" && (<HTMLElement>collection).style.pointerEvents == "none"))
            {
                var definedTag = false;
                for (var j = tags.length - 1; j > -1; j--) {
                    if (collection.tagName == tags[j]) {
                        definedTag = true;
                    }
                }
                if (definedTag == true) {
                    (<HTMLElement>collection).classList.add("exclude-undisability");
                }
            }
            
        }
    }

    private internalLoading()
    {
        this.showloading();
        this.disableElements();
        this.hideElements();
    }

    private internalNotLoading()
    {
        this.hideLoading();
        this.unDisabledElements();
        this.showElements();
    }

    private showloading()
    {
        if (this.loaderCollection != null) {
            this.callFunctionForCollection(this.loaderCollection, this.setDisplayShow, null);
        }
        else if (this.loader != null) {
            this.setDisplayShow(this.loader);
        }
    }

    private hideLoading()
    {
        if (this.loaderCollection != null) {
            this.callFunctionForCollection(this.loaderCollection, this.setDisplayNone, null);
        }
        else if (this.loader != null) {
            this.setDisplayNone(this.loader);
        }
    }

    private disableElements()
    {
        if (this.elementCollection != null) {

            for (var i = 0; i < this.elementCollection.length; i++) {
                this.disableDefinedChildElements(this.elementCollection[i], this._settings.disablableChildTags);
            }
        }
    }

    private unDisabledElements()
    {
        if (this.elementCollection != null)
        {
            for (var i = 0; i < this.elementCollection.length; i++) {
                this.removeDisabledFromDefinedChildElements(this.elementCollection[i], this._settings.disablableChildTags);
            }
        }
    }

    private hideElements()
    {
        if (this.hideElementCollection != null) {
            this.callFunctionForCollection(this.hideElementCollection, this.setDisplayNone, null);
        }
        else if (this.hideElement != null) {
            this.setDisplayNone(this.hideElement);
        }
    }

    private showElements()
    {
        if (this.hideElementCollection != null) {
            this.callFunctionForCollection(this.hideElementCollection, this.setDisplayShow, null);
        }
        else if (this.hideElement != null) {
            this.setDisplayShow(this.hideElement);
        }
    }

    private setDisplayShow(element: HTMLElement)
    {
        element.style.display = "";
    }

    private setDisplayNone(element: HTMLElement)
    {
        element.style.display = "none";
    }

    private callFunctionForElement(obj: HTMLElement, func: Function, additionalParams: any)
    {
        if (typeof additionalParams !== 'undefined')
        {
            func(obj, additionalParams);
        }
        else
        {
            func(obj);
        }
    }

    private callFunctionForCollection(obj: HTMLCollection, func: Function, additionalParams: any)
    {
        for (var i = 0; i < obj.length; i++)
        {
            if (typeof additionalParams !== 'undefined') {
                func(obj[i], additionalParams);
            }
            else {
                func(obj[i]);
            }
        }
    }


    private disableDefinedChildElements(el: Element, tags:string[])
    {
        var self = this;
        for (var i = 0; i < tags.length; i++) {
            var elements = el.getElementsByTagName(tags[i]);
            self.disableCollectionElement(<HTMLCollectionOf<HTMLElement>> elements);
        }
    }

    private disableCollectionElement(collection: HTMLCollectionOf<HTMLElement>)
    {
        for (var i = 0; i < collection.length; i++)
        {
            //We do not want to disable elements that are readonly  
            if (!collection[i].hasAttribute("readonly"))
            {
                collection[i].setAttribute("disabled", "disabled");
                if (collection[i].nodeName == "A") {
                    //This way we can disable links
                    collection[i].style.pointerEvents = "none";
                }
            }
        }
    }

    private removeDisabledFromDefinedChildElements(el: Element, tags: string[])
    {
        var self = this;
        for (var i = 0; i < tags.length; i++) {
            var elements = el.getElementsByTagName(tags[i]);
            self.removeDisabledFromCollectionElement(<HTMLCollectionOf<HTMLElement>>elements);
        }
    }

    private removeDisabledFromCollectionElement(collection: HTMLCollectionOf<HTMLElement>)
    {
        for (var i = 0; i < collection.length; i++)
        {
            if (!collection[i].classList.contains("exclude-undisability")) {
                collection[i].removeAttribute("disabled");
                if (collection[i].nodeName == "A") {
                    //This way we can disable links
                    collection[i].style.pointerEvents = "";
                }
            }
        }
    }

    isElementObject(element)
    {
        return typeof element !== "undefined" && element != null && typeof element == "object";
    }

    //Returns true if it is a DOM node
    isNode(o)
    {
        return (
            typeof Node === "object" ? o instanceof Node :
                o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string"
        );
    }

    //Returns true if it is a DOM element    
    isElement(o)
    {
        return (
            typeof o !== "undefined" && typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
                o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string"
        );
    }

}